import React from "react";
import { Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { Popover } from "@mui/material";
import ColorPicker from "./ColorPicker/ColorPicker";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import EventBus from "orion-components/SharedComponents/EventBus";
import { getDir } from "orion-components/i18n/Config/selector";
import { Translate } from "orion-components/i18n";
import PropTypes from "prop-types";

const CustomizedTextField = styled((props) => <TextField {...props} />)(
	({ width, height, paddingLeft, paddingRight, dir }) => ({
		"& label": {
			color: "#9A9FA3",
			fontSize: 10
		},
		"& label.Mui-focused": {
			color: "#9A9FA3"
		},
		"& .MuiInputBase-input": {
			...(dir === "ltr" && { paddingLeft: `${paddingLeft}!important`, paddingRight: "0px !important" }),
			...(dir === "rtl" && { paddingRight: `${paddingRight}!important`, paddingLeft: "0px !important" })
		},
		"& .MuiOutlinedInput-root": {
			fontSize: 10,
			color: "#FFFFFF",
			fontFamily: "Roboto",
			width: width || 65, // default to 59 if width prop is not provided
			height: height || 30, // default to 30 if height prop is not provided
			"& fieldset": {
				borderColor: "#5E6571"
			},
			"&:hover fieldset": {
				borderColor: "#4DB5F4"
			},
			"&.Mui-focused fieldset": {
				borderColor: "#4DB5F4"
			}
		}
	})
);

function isValidHexaDecimal(hexString) {
	const regex = /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i;
	return regex.test(hexString);
}

const FillProperties = ({ shapeType }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [color, setColor] = useState("");
	const shapesReducer = useSelector((state) => state.shapes);
	const [inputColor, setInputColor] = useState("");
	const dir = useSelector((state) => getDir(state));

	useEffect(() => {
		setColor(shapesReducer[shapeType]?.polyFill);
		setInputColor(shapesReducer[shapeType]?.polyFill);
		if (shapeType === "polygon" || shapeType === "rectangle" || shapeType === "circle") {
			EventBus.publish("drawUpdateStyles", shapesReducer[shapeType]);
		}
	}, [shapesReducer]);

	const syncColor = (colorCode) => {
		setColor(colorCode);
		EventBus.publish("drawUpdateStyles", { ...shapesReducer[shapeType], polyFill: colorCode });
	};

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const openPopover = Boolean(anchorEl);

	return (
		<div>
			<div style={{ display: "flex", position: "relative" }}>
				<div
					aria-owns={openPopover ? "fill-mouse-over-popover" : undefined}
					aria-haspopup="true"
					onMouseEnter={handlePopoverOpen}
					style={{
						width: 35,
						height: 35,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						background: shapesReducer[shapeType]?.polyFill,
						borderRadius: 5,
						opacity: 1
					}}
				>
					<img
						src={require("../icons/icon-paint-palette.png")}
						style={{ boxShadow: "1px 1px blur 2px #0000004D", paddingTop: 4 }}
					/>
				</div>
				<div
					style={{
						fontSize: 13,
						color: "#FFFFFF",
						letterSpacing: 0,
						opacity: "1",
						...(dir === "ltr" && { marginLeft: 14 }),
						...(dir === "rtl" && { marginRight: 14 }),
						fontFamily: "roboto"
					}}
				>
					<p>
						<Translate value="global.sharedComponents.shapeEditor.components.shared.fillProperties.fillColor" />
					</p>
					<p>{shapesReducer[shapeType]?.polyFillOpacity + "%"}</p>
				</div>
				<Popover
					id="fill-mouse-over-popover"
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: "top",
						horizontal: "left"
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "left"
					}}
					open={openPopover}
					onClose={handlePopoverClose}
					PaperProps={{ onMouseLeave: handlePopoverClose }}
					disableRestoreFocus // This prevents focus from leaving the popover content
				>
					<div style={{ width: 285, height: 326, backgroundColor: "#25272B" }}>
						<div style={{ height: 62, width: 283.47, backgroundColor: "#191A1D" }}>
							<div
								style={{
									paddingTop: 10,
									...(dir === "ltr" && { marginLeft: 12 }),
									...(dir === "rtl" && { marginRight: 12 }),
									display: "flex",
									marginBottom: 20,
									alignItems: "center",
									justifyContent: dir === "ltr" ? "left" : "right"
								}}
							>
								<div
									style={{
										...(dir === "ltr" && { marginRight: 5 }),
										...(dir === "rtl" && { marginLeft: 5 })
									}}
								>
									<Checkbox
										checkedIcon={
											<div
												style={{
													width: "22px",
													height: "22px",
													backgroundColor: color,
													display: "flex",
													alignItems: "center",
													justifyContent: "center"
												}}
											>
												<span style={{ color: "#FFFFFF" }}>&#x2713;</span>
											</div>
										}
										checked={true}
										onChange={() => {}}
									/>
								</div>
								<div
									style={{
										...(dir === "ltr" && { marginRight: 10 }),
										...(dir === "rtl" && { marginLeft: 10 })
									}}
								>
									<CustomizedTextField
										variant="outlined"
										name="selectedColor"
										value={inputColor}
										inputProps={{ style: { color: "#FFFFFF", fontSize: 10, fontFamily: "Roboto" } }}
										onChange={(e) => {
											setInputColor(e.target.value);
											if (isValidHexaDecimal(e.target.value)) {
												syncColor(e.target.value);
											}
										}}
										paddingLeft="6px"
										paddingRight="6px"
										dir={dir}
									/>
								</div>
							</div>
						</div>
						<ColorPicker
							defaultColor={shapesReducer[shapeType]?.polyFill}
							syncColor={syncColor}
							shapeType={shapeType}
							isForFill={true}
						/>
					</div>
				</Popover>
			</div>
		</div>
	);
};

FillProperties.propTypes = {
	shapeType: PropTypes.string.isRequired
};

export default FillProperties;
